import { render, staticRenderFns } from "./regionCheck.vue?vue&type=template&id=746607ee&scoped=true&"
import script from "./regionCheck.vue?vue&type=script&lang=js&"
export * from "./regionCheck.vue?vue&type=script&lang=js&"
import style0 from "./regionCheck.vue?vue&type=style&index=0&id=746607ee&lang=less&scoped=true&"
import style1 from "./regionCheck.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746607ee",
  null
  
)

export default component.exports